var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-souvenir',[_c('div',{staticClass:"v-souvenir"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('souvenir.title'))}}),_c('o-polaroid',{attrs:{"src":_vm.src}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }